export const GIT_HASH = '24d6a5ac'
